import React from "react"
import {
  headerHeight,
  headerHeightMd,
  headerHeightLg,
  breakpointMedium,
  breakpointLarge,
} from "../variables"
import styled from "styled-components"

const HeroEmbed = ({ slice }) => {
  const { link } = slice.primary

  return (
    <HeroContainer>
      <iframe src={link.url} frameBorder="0"></iframe>
    </HeroContainer>
  )
}

export default HeroEmbed

const HeroContainer = styled.section`
  height: ${`calc(375px - ${headerHeight})`};
  width: 100%;

  iframe {
    height: 100%;
    width: 100%;
  }

  @media (min-width: ${breakpointMedium}) {
    height: ${`calc(541px - ${headerHeightMd})`};
  }

  @media (min-width: ${breakpointLarge}) {
    height: ${`calc(820px - ${headerHeightLg})`};
  }
`
